module.exports = __webpack_public_path__ + "img/1698343540897.0107a9c3.jpg";